export const getNetsOptionDescription = (immediateReservation: boolean) => {
  if (immediateReservation) {
    return "Beløpet reserveres ved bestilling, og trekkes først når varen(e) sendes fra oss.";
  }
  return "Du betaler kun for det du mottar. Kortet ditt trekkes først når varen(e) sendes fra oss.";
};
